import styled from "@emotion/styled";
import { color } from "@smartsheet/design-tokens-react";
import { ttNormsFontFamily, ttNormsVarFontFamily } from "../../../fonts/fonts";
import { typeRampLodestarDefinitions } from "../constants/lodestarConstants";
import { ursaTypeRampDefinitions, lodestarToUrsaVariantMap, ursaSemanticTypeRampDefinitions } from "../constants/ursaConstants";
const isLodestarVariant = variant => variant in typeRampLodestarDefinitions;
const isUrsaSemantic = variant => variant in ursaSemanticTypeRampDefinitions;
const isUrsaSemanticHeading = variant => ["h1", "h2", "h3", "h4", "h5", "h6"].includes(variant);
const getFontStyles = (system, variant, themeMode) => {
  const isUrsa = system === "ursa" || themeMode.includes("ursa");
  const isLodeStar = system === "lodestar" && themeMode === "lodestar-light";
  //adding if blocks instead of conditionally destructuring off of ursaTypeRampDefinitions or typeRampLodestarDefinitions
  // so we can easily support additional systems/themes in the future.
  if (isUrsa) {
    const {
      fontFamily,
      fontWeight,
      fontSize,
      lineHeight
    } = isLodestarVariant(variant) ? lodestarToUrsaVariantMap[variant] : ursaTypeRampDefinitions[variant] || ursaSemanticTypeRampDefinitions[variant];
    return `
        font-weight: ${fontWeight}; 
        font-size: ${fontSize}; 
        line-height: ${lineHeight};
        font-family: ${fontFamily === ttNormsFontFamily ? `${ttNormsFontFamily};
            @supports (font-variation-settings: normal){
                font-family: ${ttNormsVarFontFamily};
            }` : ``};`;
  } else if (isLodeStar) {
    const {
      fontFamily,
      fontWeight,
      fontSize,
      lineHeight
    } = typeRampLodestarDefinitions[variant];
    if (fontFamily === "TT Norms Pro") return `
            font: ${fontWeight} ${fontSize}/${lineHeight} ${ttNormsFontFamily};
            @supports (font-variation-settings: normal){
                font-family: ${ttNormsVarFontFamily};
            };
        `;
    return `font-weight: ${fontWeight}; font-size: ${fontSize}; line-height: ${lineHeight};`;
  }
  //handle additional systems/themes or custom themes
  //return ``;
};

const getColor = (system, variant, themeMode) => {
  if (isUrsaSemantic(variant)) {
    if (isUrsaSemanticHeading(variant)) {
      return `color: ${color("color--text--neutral--strong")};`;
    }
    return `color: ${color("color--text--neutral--default")};`;
  }
  if (themeMode.includes("ursa") && isLodestarVariant(variant)) {
    return `color: ${typeRampLodestarDefinitions[variant].color};`;
  }
  return `${system === "lodestar" && themeMode === "lodestar-light" ? `color: ${typeRampLodestarDefinitions[variant].color};` : ``}`;
};
//eslint-disable-next-line
export const TypeRampRoot = styled("span")`
    ${_ref => {
  let {
    system = "ursa",
    variant,
    themeMode
  } = _ref;
  return getFontStyles(system, variant, themeMode);
}}
    ${_ref2 => {
  let {
    system = "ursa",
    variant,
    themeMode
  } = _ref2;
  return getColor(system, variant, themeMode);
}}
    ${_ref3 => {
  let {
    lineClamp
  } = _ref3;
  return lineClamp !== undefined ? `
            overflow: hidden;
            ${
  // Because lineClamp tends to be buggy in certain use cases (such as multiple lines
  // of elided text) We will use the old school ellipsis method for single line
  // clamping.
  lineClamp === 1 ? `
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    ` : `
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: ${lineClamp};
                        line-clamp: ${lineClamp};
                    `}
        ` : "";
}}
    ${_ref4 => {
  let {
    includeTTNormsProVarFont
  } = _ref4;
  return includeTTNormsProVarFont ? `
            font-family: ${ttNormsFontFamily};

            @supports (font-variation-settings: normal) {
                font-family: ${ttNormsVarFontFamily};
            }
        ` : "";
}}
`;
//# sourceMappingURL=TypeRampV2Styles.js.map